module.exports = __webpack_public_path__ + "static/media/lady_be_good.176c2072.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/recordings/lady_be_good.mp3
// module id = 48
// module chunks = 0